
const preferences = {
  preferences: {
    pendingRefresh: true,
    properties: {},
    loaded: false
  }
}

export {preferences as default}
